import { createSelector } from 'reselect'

export const getSelectableUserTypes = createSelector(
  (state) => state && state.common && Array.isArray(state.common.selectableUserTypes) ? state.common.selectableUserTypes : [],
  (selectableUserTypes) => selectableUserTypes
)
